import { fetcher } from "../../utils/fetcher.js";

export const getNotifications = (limit = 50) =>
  fetcher.get(`/api/notifications?limit=${limit}`);
